import React, { useState } from 'react';
import { Box } from '@mui/material';
import { getInitials, colorForName } from './BusinessLogo';

// Product thumbnail: shows the image when available, otherwise the product
// name initials — mirrors BusinessLogo so products always have a visual.
// Fills its parent by default; pass `sx` with width/height to size it directly.
export default function ProductImage({ src, name, onClick, fontSize = '1rem', sx = {} }) {
    const [imgError, setImgError] = useState(false);
    if (src && !imgError) {
        return (
            <Box component="img" src={src} alt={name || ''} onClick={onClick}
                onError={() => setImgError(true)}
                sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', bgcolor: '#f5f5f5', ...sx }} />
        );
    }
    return (
        <Box onClick={onClick} sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: colorForName(name),
            color: '#fff',
            fontWeight: 700,
            fontSize,
            textTransform: 'uppercase',
            userSelect: 'none',
            ...sx,
        }}>
            {getInitials(name)}
        </Box>
    );
}
